import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class SetImageToPurge extends Component {
	render() {
		return (
			<div className="technical-main">
				<Breadcrumbs />
				<div className="technical-content">
					<h1 className="main-heading">
						Image Purge Web Service
                    </h1>
					<div>
						<h2 className="main-subheading">SetImageToPurge</h2>
						<div className="technical-main-content">
							<p>The SetImageToPurge method is to mark an image for purge as confirmed by the customer or decommissions clients. The request will receive a unique identifier for an image. This ID identifies the image that should be marked for purge. The marked design images will be removed from the AAM image storage drive in the next daily image purging process.</p>
							<p>In addition to the unique identifier, other parameters are required for the web service request to correctly identify the Service Aggregator, Subscriber and maybe the Product. These will be random, unique strings so that the bureau cannot request images from Service Aggregators, Subscribers or even Products it should not have access to. This parameter is named as Image Purge Key.</p>
							<h3>WSDL URL</h3>
							<p>Thales will provide the WSDL URL for DevServer during the project.</p>
							<br />
							<h3>Request Parameters</h3>
							<ul>
								<li><b>CardImageID</b> (string)
							<p>The unique identifier for the image being requested, This is generated by the Designer Website and passed to the Subscriber during the Handback procedure.
							</p></li>
								<li><b>ImagePurgeKey </b> (GUID string)
								<p>This value identifies the caller and is matched to the Service Aggregator. This guarantees that the caller should have access to the requested CardImageID. Thales will provide the Aggregator with the value for this parameter. Also note that a different value will be used on each environment.
							</p></li>
							</ul>
							<br />

							<h3>Response Paramters</h3>
							<p>The response parameter is an integer value which specifies following:</p>
							<ul>
								<li><b>-2 (Authentication error)</b>
							<p>An internal error occurred. This indicates that the caller is not allowed to make a request due to IP transparency check.</p>
								</li>
								<li><b>-1 (Unexpected system error)</b>
							<p>An internal error occurred. The caller should attempt to call the method again. If a high number of such errors are encountered, the problem should be escalated to manual operators at Thales.</p>
								</li>
								<li><b>0 (Success)</b>
							<p>The method call was successful.</p>
								</li>
								<li><b>1 (CardImageID is invalid)</b>
							<p>The CardImageID isn’t a valid identifier.</p>
								</li>
								<li><b>2 (ImagePurgeKey is invalid or doesn’t match CardImageId)</b>
							<p>The CardImageID and ImagePurgeKey don’t match. This error will usually occur when an invalid or incorrect ImagePurgeKey is used.</p>
								</li>
							</ul>
						</div>
						<br/>
						<div className="document-content-back">
							<Link className="document-content-link" to='/technical/imagepurge'>Back</Link>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default SetImageToPurge;